import type { EventYear } from '../../types';
// No dedicated 2026 hero image yet — reuse the Miami hero until one is provided.
import miamiHeroImage from '../../../assets/images/AdobeStock_1393129687.webp';

import { agenda } from './agenda';
import { locations } from './locations';
import { logistics } from './logistics';
import { theme } from './theme';

export const event2026: EventYear = {
  meta: {
    year: 2026,
    title: 'Annual General Meeting',
    tagline: 'Join us in Miami for our Annual General Meeting',
    displayDate: 'December 7-8, 2026',
    city: 'Miami, Florida',
    venueName: 'Andaz Miami Beach',
    heroImage: miamiHeroImage,
    isCurrent: true,
  },
  agenda,
  agendaNotes: [
    'This is our working agenda and is subject to change.',
    'Final details, including speakers, session timings, and locations, will be shared closer to the event.',
  ],
  locations,
  logistics,
  theme,
};
